import axios from '@/axios.js'

export default {
  getKioskPassword({commit}){
    // console.log("data", data);
    return new Promise((resolve, reject) => {
      axios
        .get("auth-drcc/kiosk-password")
        .then((response) => {
          // console.log("response_dealer", response);
          commit('GET_KIOSK_PASSWORD',response.data.data)
          resolve(response.data.data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
  updateKioskPassword({commit},payload){
    // console.log("data", data);
    return new Promise((resolve, reject) => {
      axios
        .put("auth-drcc/kiosk-password-update", payload)
        .then((response) => {
          // console.log("response_dealer", response);
          commit('GET_KIOSK_PASSWORD',response.data.data)
          resolve(response.data.data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
  getKioskExpiry({commit}){
    return new Promise((resolve, reject) => {
      axios
        .get("sales-and-purchase/queue-setting")
        .then((response) => {
          commit('GET_KIOSK_EXPIRY',response.data.data)
          resolve(response.data.data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
  updateKioskExpiry({commit},payload){
    return new Promise((resolve, reject) => {
      axios
        .put("sales-and-purchase/queue-setting", payload)
        .then((response) => {
          commit('GET_KIOSK_EXPIRY',response.data.data)
          resolve(response.data.data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
  fetchKioskDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/sales-and-purchase/drcc/kiosk-dashboard', {
        params: payload
      }).then((response) => {
        /**
         * response.data expected
         * {
         *   counterList:['counterA','counterB','counterC']
         *   data:[
         *     {
         *       itemModel:'model-a
         *       counterA: 0,
         *       counterB:1,
         *       counterC:1,
         *       reserved :2,
         *       picked:2,
         *       location:'-',
         *       noStock:false
         *     },
         *     {
         *       itemModel:'model-b
         *       counterA: 1,
         *       counterB:0,
         *       counterC:0,
         *       reserved :1,
         *       picked:0,
         *       location:'-',
         *       noStock:true 
         *     },
         *   ]
         * }
         */
        commit('SET_DASHBOARD_FIELD', response.data.counterList)
        commit('SET_DASHBOARD_DATA', response.data.data)
        resolve(response.data);
      }).catch((e) => {
        console.error(e);
        reject(e)
      })
    })
  },
  removePoFail({ commit }, payload) {
    //payload is id
    return new Promise((resolve, reject) => {
      axios.delete('/sales-and-purchase/failpurchase/' + payload).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        console.error(e);
        reject(e)
      })
    })
  },
  getPurchase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/sales-and-purchase/purchase', {
        params: payload
      }).then((response) => {
        commit('SET_PURCHASE', response.data.data)
        resolve(response.data);
      }).catch((e) => {
        console.error(e);
        reject(e)
      })
    })
  },
  getFailPurchase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/sales-and-purchase/failpurchase', {
        params: payload
      }).then((response) => {
        commit('SET_FAILPURCHASE', response.data.data)
        resolve(response.data);
      }).catch((e) => {
        console.error(e);
        reject(e)
      })
    })
  },
  savePurchaseDraft ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post('sales-and-purchase/purchase/draft', data).then((response) => {
        resolve(response.data.data)
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
    
  },
  updatePurchaseDraft : ({ commit }, { id, data }) => {
    return new Promise((resolve, reject) => {
      axios
        .put('sales-and-purchase/purchase/draft/' + id, data)
        .then(res => {         
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  
  detailPurchase:({ commit }, { id })=>{
    return new Promise((resolve, reject) => {
      axios
        .get('/sales-and-purchase/purchase/detail/'+id)
        .then(res => {
          commit('GET_PURCHASE_ID',res.data.data)
          resolve(res.data.data);
        })
        .catch(err => {
          console.error(err);
          //alert(err);
          reject(err);
        });
    })
    
  },
  resetPurchaseById: ({ commit }) => {
    commit('RESET_PURCHASE_ID');
  },
  deletePurchase: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      axios
        .delete('/sales-and-purchase/purchase/' + id)
        .then(() => {
          commit('DELETE_PURCHASE', id)
          resolve()
        })
        .catch(err => {
          //alert(err.message)
          reject(err)
        })
    })
  },
  addKioskPo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/sales-and-purchase/kiosk-purchase-order", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  editStatusKioskPo({ commit }, {id, data}) {
    return new Promise((resolve, reject) => {
      axios
        .put("/sales-and-purchase/kiosk-purchase-order/"+id, data)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  editKioskPo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put("/sales-and-purchase/kiosk-purchase-order", payload)
        .then((response) => {
          var data = response.data.data;
          resolve(data);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  checkStockKioskPO({ commit }, {id, data}) {
    return new Promise((resolve, reject) => {
      axios
        .put("/sales-and-purchase/kiosk-purchase-order/checkStock/"+id, data)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  claimCheckStockKioskPO({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .put("/sales-and-purchase/kiosk-purchase-order/checkStock/"+id+"/claim")
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  releaseCheckStockKioskPO({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .put("/sales-and-purchase/kiosk-purchase-order/checkStock/"+id+"/release")
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  addCounterIDToPO({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("sales-and-purchase/kiosk-purchase-order/add-counter-id", payload)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  getPurchaseByPONumber({ commit }, poNumber) {
    return new Promise((resolve, reject) => {
      axios
        .get("sales-and-purchase/get-purchase-by-po-number/"+poNumber)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  getPOByToken({ commit }, token) {
    return new Promise((resolve, reject) => {
      axios
        .get("sales-and-purchase/get-po-by-token/"+token)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  },
  resendKioskPO({ commit }, { poNumber }) {
    return new Promise((resolve, reject) => {
      axios
        .post("/sales-and-purchase/resend-kiosk/" + poNumber)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
}
